<template>
	<div id="lang">
		<md-menu md-direction="bottom-start">
			<md-button class="md-fab md-elevation-4" md-menu-trigger>
				<md-button class="md-fab md-primary">
					<md-icon>language</md-icon>
				</md-button>
			</md-button>
			<md-menu-content>
				<md-menu-item @click="changeLang('it-IT')"><span>Italiano</span></md-menu-item>
				<md-menu-item @click="changeLang('en-GB')"><span>English</span></md-menu-item>
			</md-menu-content>
		</md-menu>
	</div>
</template>

<script>
export default {
	name: "ChangeLang",
	methods: {
		changeLang(lang) {
			localStorage.setItem("lang", lang)
			this.$i18n.locale = lang
			this.$root.$i18n.locale = lang
		}
	}
}
</script>

<style scoped lang="scss">
#lang {
	position: absolute !important;
	left: 50%;
	-ms-transform: translate(-50%, -50%);
	transform: translate(-50%);
}
</style>
